import { Refresh } from '@mui/icons-material';
import { FC, useCallback } from 'react';
import {
  Button,
  useDataProvider,
  useRecordContext,
  useRefresh,
} from 'react-admin';

export const ReuseButton: FC = () => {
  const record = useRecordContext();
  const dp = useDataProvider();
  const refresh = useRefresh();

  const handleReuse = useCallback(async () => {
    await dp.create('prompt', {
      data: { prompt: record.prompt, temperature: record.temperature },
    });
    refresh();
  }, [dp, record.prompt, record.temperature, refresh]);

  return (
    <Button
      label="Переиспользовать"
      startIcon={<Refresh />}
      onClick={handleReuse}
    />
  );
};
